<template>
  <b-modal :active.sync="isActive" full-screen>
    <div class="referral-modal">
      <h2 class="title mb-6 mt-6 pt-5">Your Referral QR Code</h2>

      <p class="subtitle">
        Show this code with customers to send them straight to our site. You’ll
        earn commissions on every sale made using your referral link.
      </p>

      <div class="qr-container">
        <div>
          <div class="qr-card">
            <qrcode-vue
              :value="referralCode"
              :size="180"
              level="L"
              background="#c2ffdd"
              foreground="#5584F1"
            />
            <hr />
            <img src="../assets/logo_full.png" class="img-small mt-1" />
          </div>

          <div
            class="scan-text mb-5 is-flex is-align-items-center is-justify-content-center"
          >
            <b-icon icon="qrcode" size="is-small" class="mr-2"></b-icon>
            SCAN TO VISIT OUR SITE
          </div>
        </div>
      </div>

      <div class="blue-button" @click="isActive = false">Close</div>
    </div>
  </b-modal>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "ReferralQrModal",

  components: {
    QrcodeVue,
  },

  props: {
    active: Boolean,
    referralCode: String,
  },

  computed: {
    isActive: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit("update:active", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.img-small {
  height: 1.5rem;
}
.referral-modal {
  text-align: center;
  padding: 30px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 1.8rem;
  font-weight: 700;
  flex-shrink: 0;
}

.subtitle {
  color: #6b7c93;
  font-size: 1rem;
  flex-shrink: 0;
}

.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  hr {
    background-color: #fff;
    border: none;
    display: block;
    height: 4px;
    margin: 1rem -40px;
  }
}

.qr-card {
  background-color: #c2ffdd;
  padding: 30px 40px 12px 40px;
  border-radius: 12px;
  display: inline-block;
}

.qr-title {
  margin-bottom: 10px;
  font-weight: 600;
}

.scan-text {
  margin-top: 20px;
  letter-spacing: 2px;
  color: #7a8ca5;
  font-size: 0.8rem;
}

.b-button,
button,
.button {
  flex-shrink: 0;
  margin-top: auto;
  width: 100%;
}
</style>
